import _ from 'underscore';
import { isGroupCreative } from '../utils';

export default function SavedController(
  $state,
  CreativeService,
  CreativeGroupService,
  CreativeListService,
  CurrentUserService,
  DataService,
  FlashService,
  RenderService,
  MixpanelService,
  RtbPixelService,
  DcoAssetsService,
  creativeResponse,
  partner
) {
  const vm = this;
  vm.creativeFound = !!creativeResponse.data;
  vm.renderService = RenderService;
  vm.creativeService = CreativeService;
  vm.partner = partner;
  vm.userOwnsCreative = false;
  vm.deleteCreative = deleteCreative;
  vm.showEmbedLink = true;
  vm.creativeIsFromDco = false;

  const isDsp = (partner) => !!partner && partner.partnerType === 'DSP';

  vm.canExportCreatives = () => {
    const { creatives, partner } = vm;
    if (!creatives || creatives.length === 0 || !isDsp(partner)) {
      return false;
    }

    const { action } = creatives[0];

    return action !== 'banner' && action !== 'instream-video';
  };

  vm.canExportVast = () => {
    const { creatives, partner } = vm;
    if (!creatives || creatives.length === 0 || !isDsp(partner)) {
      return false;
    }
    const { action, status } = creatives[0];

    return action === 'instream-video' && status === 'complete';
  };

  CurrentUserService.get().then(user => {
    vm.user = user;
    vm.showNewAdBuilder = isGroupCreative(CreativeService.creative);
  });

  // TODO: not great, should just check the one
  DataService.initUserCreatives().then(() => {
    vm.userOwnsCreative = !!_.find(
      DataService.userCreatives,
      ({ id }) => `${id}` === $state.params.id
    );

    vm.creatives = [CreativeService.creative];

    if (CreativeService.isFromDco()) {
      vm.creativeIsFromDco = true;
      fetchDcoAssets(CreativeService.creative);
    }

    vm.name = CreativeService.creative.name;
  });

  if ($state.params.id) {
    trackViewedDemo();

    if (creativeResponse.data && creativeResponse.data.creativePreviews) {
      CreativeGroupService.setCreativeGroup(creativeResponse.data);
    } else if (creativeResponse.data) {
      CreativeGroupService.setCreativeGroup({
        name: null,
        creativePreviews: [creativeResponse.data]
      });
    }

    RenderService.setSite();
    RtbPixelService.get();
  }

  function trackViewedDemo() {
    if ($state.current && $state.current.name === 'creativePreview.saved') {
      MixpanelService.track('Viewing Saved Demo', {
        demoId: $state.params.id
      });
    }
  }

  function deleteCreative() {
    return DataService.destroy(CreativeService.creative.id).then(() => {
      FlashService.push('success', 'Creative Successfully Deleted');
      return CreativeListService.refreshList().then(() => {
        $state.go('creativePreview.home');
      });
    });
  }

  function fetchDcoAssets(creative) {
    DcoAssetsService.fetch(creative.dcoUrl)
      .then(responseCreative => {
        const updCreative = Object.assign(creative, responseCreative);
        CreativeService.setCreative(updCreative);
      })
      .catch(() => {
        FlashService.push(
          'error',
          'The provided DCO URL responded with an error :('
        );
      });
  }

  return vm;
}

SavedController.$inject = [
  '$state',
  'CreativeService',
  'CreativeGroupService',
  'CreativeListService',
  'CurrentUserService',
  'DataService',
  'FlashService',
  'RenderService',
  'MixpanelService',
  'RtbPixelService',
  'DcoAssetsService',
  'creativeResponse',
  'partner'
];
